if (!customElements.get('collection-block')) {
  class CollectionBlock extends HTMLElement {
    constructor() {
      super();

      this.slider = this.querySelector('[data-slider]');
      this.mobileSlider = this.querySelector('[data-mobile-slider]');
      this.options = {
        loop: true,
        autoplay: {
          delay: 3000,
        },
      };
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (this.slider) {
        new Swiper(
          this.slider,
          this.options,
        );
      }

      if (this.mobileSlider) {
        new Swiper(
          this.mobileSlider,
          this.options,
        );
      }
    }

  }

  customElements.define('collection-block', CollectionBlock);
}
